import React, { useState, useEffect } from 'react';
import { losApi } from '../../losApi';
import { toast } from '../../../hooks/use-toast';
import { errorMessage } from '../../errors';
import { Textarea } from '../../../components/ui/textarea';
import { Label } from '../../../components/ui/label';
import { ModuleHeader, Fld } from '../shared/formFields';
import AriveBadge from '../../board/AriveBadge';
import { ariveDeepLink, isAriveManaged, toastAriveConflict } from '../../ariveManaged';

export function RateLockTab({ loan, onChange }) {
  const [lock, setLock] = useState(loan.rate_lock || {});
  const [saving, setSaving] = useState(false);
  const locked = isAriveManaged(loan); // rate_lock is Arive-owned on a synced loan
  useEffect(() => setLock(loan.rate_lock || {}), [loan]);
  const upd = (k, v) => setLock(l => ({ ...l, [k]: v }));
  const save = async () => {
    setSaving(true);
    try { await losApi.updateRateLock(loan.loan_file_id, lock); toast({ title: 'Rate lock saved' }); onChange(); }
    catch (e) { if (!toastAriveConflict(e)) toast({ title: 'Failed', description: errorMessage(e) }); }
    finally { setSaving(false); }
  };
  return (
    <div className="space-y-4">
      <ModuleHeader title="Products & Pricing / Rate Lock" onSave={save} saving={saving} />
      {locked && (
        <div className="flex items-center gap-2 text-[12px] text-slate-500" data-testid="rate-lock-arive-note">
          <AriveBadge deepLink={ariveDeepLink(loan)} /> The rate lock is edited in Arive.
        </div>
      )}
      <fieldset disabled={locked} className="bg-white rounded-xl border border-slate-200 p-5 space-y-4 max-w-3xl min-w-0">
        <label className="flex items-center gap-2 text-[13px] font-semibold">
          <input type="checkbox" checked={!!lock.is_locked} onChange={(e) => upd('is_locked', e.target.checked)} data-testid="rate-lock-toggle" />
          Locked
        </label>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          <Fld label="Lock Date" type="date" value={lock.lock_date?.substring(0, 10)} onChange={(v) => upd('lock_date', v ? new Date(v).toISOString() : null)} />
          <Fld label="Expiration" type="date" value={lock.expiration_date?.substring(0, 10)} onChange={(v) => upd('expiration_date', v ? new Date(v).toISOString() : null)} />
          <Fld label="Rate %" kind="number" step="0.001" value={lock.rate} onChange={(v) => upd('rate', Number(v))} />
          <Fld label="Term (days)" kind="number" value={lock.lock_term_days} onChange={(v) => upd('lock_term_days', Number(v))} />
          <Fld label="Product" value={lock.product} onChange={(v) => upd('product', v)} placeholder="30 Yr Fixed" />
          <Fld label="Lender" value={lock.lender} onChange={(v) => upd('lender', v)} />
          <Fld label="Lender Loan #" value={lock.lender_loan_number ?? (locked ? loan.arive?.lender_loan_identifier : '')} onChange={(v) => upd('lender_loan_number', v)} testId="rate-lock-lender-loan" />
          <Fld label="Price" kind="number" step="0.001" value={lock.price} onChange={(v) => upd('price', Number(v))} placeholder="100.125" />
        </div>
        <div><Label className="text-xs">Notes</Label>
          <Textarea rows={2} value={lock.notes || ''} onChange={(e) => upd('notes', e.target.value)} className="mt-1" /></div>
      </fieldset>
    </div>
  );
}
